// extracted by mini-css-extract-plugin
export default {"createReceiptHolder":"Receipt_createReceiptHolder__NLwlz","btnHolder":"Receipt_btnHolder__WCSMU"};